import {
    CaretDownOutlined,
    CloseCircleFilled,
    InfoCircleTwoTone,
    MinusCircleOutlined,
} from '@ant-design/icons'
import {
    Button,
    Checkbox,
    Col,
    Collapse,
    Form,
    Input,
    notification,
    Popconfirm,
    Popover,
    Row,
    Select,
    Spin,
    Switch,
    Tag,
} from 'antd'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import {
    recipeNameAvailableApi,
    editRecipeApi,
    listOfDiseasesApi,
    listOfIngredientFormApi,
    listOfIngredientsApi,
    listOfIngredientUnitApi,
    listOfMacrosMicrosApi,
    listOfMealTimeApi,
    listOfRecipeCategoriesApi,
    listOfRecipeTagsApi,
    listOfRecipeTypesApi,
} from '../../../../config/Api'
import {
    API_ERR_MESSAGE,
    BASE_URL,
    NUMBER_AND_FRACTIONAL_PATTERN,
    NUMBER_AND_FRACTIONAL_PATTERN_MESSAGE,
} from '../../../../config/constant'
import { readAuthCookie } from '../../../../config/CookieScript'
import { FilterApiData } from '../../../../services/FilterApiData'
import { setHeaderName } from '../../../../services/SetHeaderName'
import { apiErrorMessage } from '../../../../services/ApiError'
import '../style/AddOrEditRecipe.scss'

export const AddOrEditRecipe = () => {
    const [form] = Form.useForm()
    const { Option } = Select
    const { Panel } = Collapse
    const { id } = useParams()
    const navigate = useNavigate()

    const [macrosMicrosOptions, setMacrosMicrosOptions] = useState([])

    const [recipeImageUrl, setRecipeImageUrl] = useState('')
    const [ingredientMeasurementType, selectedIngredientMeasurementType] =
        useState('gram')
    const [preparationSteps, setPreparationSteps] = useState([])
    const [categoryOptions, setCategoryOptions] = useState([])
    const [recipetypeOptions, setRecipetypeOptions] = useState([])
    const [mealTimeOptions, setMealTimeOptions] = useState([])
    const [recipeTagsOptions, setRecipeTagsOptions] = useState([])
    const [diseasesOptions, setDiseasesOptions] = useState([])
    const [ingredientFormOptions, setingredientFormOptions] = useState([])
    const [ingredientUnitOptions, setingredientUnitOptions] = useState([])
    const [ingredientsList, setIngredientsList] = useState([])
    const [loading, setLoading] = useState(false)
    // true while a save is on its way, so extra clicks don't create the recipe twice
    const [saving, setSaving] = useState(false)

    // an ingredient amount (gram or ml) must be a plain number greater than 0
    const INGREDIENT_AMOUNT_MESSAGE = 'Enter an amount greater than 0'
    const isValidIngredientAmount = (value) =>
        NUMBER_AND_FRACTIONAL_PATTERN.test(String(value ?? '').trim()) && parseFloat(value) > 0

    const [totalMicros, setTotalMicros] = useState([])

    const [priviewImg, setPriviewImg] = useState()
    const [file, setfile] = useState()
    const [depriciation, setDepriciation] = useState(false)

    // set selected ingredient data
    const [ingredientData, setIngredientData] = useState()
    const [selectedIngredientForm, setSelectedIngredientForm] = useState()

    // console.log('ingredientData', ingredientData);
    // state for prevent useEffect called multiple times
    const [rendered, setRendered] = useState(false)
    const [userId, setUserId] = useState('')

    const [totalPrapationSteps, setTotalPrapationSteps] = useState(0)
    const [servingSize, setServingSize] = useState(1)
    const [flag, setFlag] = useState(false)
    const [recipePhenoType, setRecipePhenoType] = useState([])
    const [arrayOfSelectedDropdownValue, setArrayOfSelectedDropdownValue] =
        useState([])
    const [arrayOfMealTime, setArrayOfMealTime] = useState([])
    const [selectedIngredientsList, setSelectedIngredientsList] = useState([])

    const [existRecipeData, setExistRecipeData] = useState({})

    const [ingredientErr, setIngredientErr] = useState('')
    const [formErr, setFormErr] = useState('')
    const [quantityErr, setQuantityErr] = useState('')
    const [unitErr, setUnitErr] = useState('')
    const [gramErr, setGramErr] = useState('')

    const [preparationStepsErr, setPreparationStepsErr] = useState('')
    const [totalIngredientsErr, setTotalIngredientsErr] = useState('')

    // handle pheno type array
    // console.log('Kapha', recipePhenoType.includes('Kapha') ? 'Kapha' : '')
    // console.log('Pitta', recipePhenoType.includes('Pitta') ? 'Pitta' : '')
    // console.log('Vata', recipePhenoType.includes('Vata') ? 'Vata' : '')

    // here create an array of object all tags related selected dropdown values
    // =================================
    const CreateArrayOfSelectedValue = (id, task) => {
        console.log(id)
        console.log(task)
        let object = recipeTagsOptions.find((element) => element.id == id)
        if (task == 'add') {
            // if selected option object is available inside array only push if not available
            let valueExist = arrayOfSelectedDropdownValue.find(
                (element) => element.recipe_tag_id == object.id
            )
            console.log(arrayOfSelectedDropdownValue)
            if (!valueExist) {
                object.recipe_tag_id = object.id
                // console.log(object,valueExist);

                arrayOfSelectedDropdownValue.push(object)
            }
            console.log(arrayOfSelectedDropdownValue)
        }
        if (task == 'remove') {
            const indexOfElement = arrayOfSelectedDropdownValue.findIndex(
                (record) => record.recipe_tag_id == object.id
            )
            arrayOfSelectedDropdownValue.splice(indexOfElement, 1)
            console.log(arrayOfSelectedDropdownValue)
        }
    }

    // here we get the list of selected array of selected checkboxes id
    // from that id we get the object from its options array and push it into the state
    // =================================
    const CreateArrayOfMealTime = (data) => {
        console.log(data)

        setArrayOfMealTime([])
        let temp = []
        data.map((record, index) => {
            let object = mealTimeOptions.find((element) => element.id == record)
            object.meal_time_id = object.id
            //delete object.id
            // if(){
            temp.push(object)
            // }
        })
        setArrayOfMealTime(temp)
        console.log(temp)
    }

    // get the list of all Macros Micros
    // =================================
    const getListOfMacrosMicros = async () => {
        await listOfMacrosMicrosApi()
            .then((res) => {
                if (res.status === 200) {
                    setMacrosMicrosOptions(res.data.data)
                }
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                })
            })
    }

    // get the list of all Ingredients List and its data
    //==========================================
    const getListOfIngredients = () => {
        listOfIngredientsApi()
            .then((res) => {
                if (res.status === 200) {
                    if (res.data.data && res.data.data?.length > 0) {
                        setIngredientsList(FilterApiData(res.data.data))
                    }
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                })
            })
    }
    const MacrosMicrosList = [
        {
            id: '1',
            name: 'Vitamin A',
            type: 'Micros',
            unit: 'µg',
            status: true,
        },
        {
            id: '2',
            name: 'Energy',
            type: 'Macros',
            unit: 'Kcal',
            status: false,
        },
        {
            id: '4',
            name: 'Protein',
            type: 'Macros',
            unit: 'g',
            status: true,
        },
        {
            id: '5',
            name: 'Total Fat',
            type: 'Macros',
            unit: 'g',
            status: true,
        },
        {
            id: '6',
            name: 'Carbohydrate',
            type: 'Macros',
            unit: 'g',
            status: true,
        },
        {
            id: '7',
            name: 'Dietary Fiber',
            type: 'Macros',
            unit: 'g',
            status: true,
        },
        {
            id: '8',
            name: 'Ascorbic acids (C)',
            type: 'Micros',
            unit: 'mg',
            status: true,
        },
        {
            id: '10',
            name: 'Vitamin D',
            type: 'Micros',
            unit: 'µg',
            status: true,
        },
        {
            id: '11',
            name: 'α -Tocopherol equivalent (E)',
            type: 'Micros',
            unit: 'mg',
            status: true,
        },
        {
            id: '12',
            name: 'Vitamin K',
            type: 'Micros',
            unit: 'µg',
            status: true,
        },
        {
            id: '13',
            name: 'Thiamine (B1)',
            type: 'Micros',
            unit: 'mg',
            status: true,
        },
        {
            id: '14',
            name: 'Riboflavin (B2)',
            type: 'Micros',
            unit: 'mg',
            status: true,
        },
        {
            id: '15',
            name: 'Total B6',
            type: 'Micros',
            unit: 'mg',
            status: true,
        },
        {
            id: '16',
            name: 'Folates (B9)',
            type: 'Micros',
            unit: 'µg',
            status: true,
        },
        {
            id: '17',
            name: 'Calcium (Ca)',
            type: 'Micros',
            unit: 'mg',
            status: true,
        },
        {
            id: '18',
            name: 'Iron (Fe)',
            type: 'Micros',
            unit: 'mg',
            status: true,
        },
        {
            id: '19',
            name: 'Potassium (K)',
            type: 'Micros',
            unit: 'mg',
            status: true,
        },
        {
            id: '20',
            name: 'Sodium (Na)',
            type: 'Micros',
            unit: 'mg',
            status: true,
        },
        {
            id: '21',
            name: 'Zinc (Zn)',
            type: 'Micros',
            unit: 'mg',
            status: true,
        },
        {
            id: '22',
            name: 'Phophorus (P)',
            type: 'Micros',
            unit: 'mg',
            status: true,
        },
    ]

    //  same recipe name is not allowed when user the creation of recipe user and login user are diffrent
    // check with the server that no other recipe has this name
    // when editing, the server decides whether the recipe's own name counts:
    // it's ignored for the owner, but editing someone else's recipe saves a new copy that needs a new name
    const validateNameAvailable = async (_, value) => {
        const name = (value || '').trim()
        if (!name) return

        let res
        try {
            res = await recipeNameAvailableApi(name, id)
        } catch (err) {
            // can't check right now: the save itself still refuses duplicates
            return
        }
        if (res?.data?.available === false) {
            throw new Error(res.data.message)
        }
    }

    function compareRecipeNames(str1, str2) {
        // Remove spaces from both strings
        const cleanedStr1 = str1.replace(/\s/g, '')
        const cleanedStr2 = str2.replace(/\s/g, '')

        // Compare the modified strings
        return cleanedStr1 === cleanedStr2
    }

    // call When user click on save button for Recipe
    // =================================
    const onFinish = (values) => {
        // values.image = file
        // console.log(values);
        // console.log(arrayOfMealTime);

        setIngredientErr('')
        setFormErr('')
        setPreparationStepsErr('')
        setTotalIngredientsErr('')

        let valid = true
        // the first missing part, so the page can scroll to its message (it can be far above the button)
        let firstErrorId = null

        let preparation_step = form.getFieldValue('preparation_steps')
        // console.log("preparation_step final", preparation_step);
        if (!selectedIngredientsList || selectedIngredientsList?.length == 0) {
            setTotalIngredientsErr('Insert Recipe Ingredients')
            valid = false
            firstErrorId = firstErrorId || 'recipe-ingredients-error'
        }
        if (!preparation_step || preparation_step?.length == 0) {
            setPreparationStepsErr('insert Prepraration Steps')
            valid = false
            firstErrorId = firstErrorId || 'recipe-preparation-steps-error'
        }
        if (!valid) {
            notification.error({
                message: "Recipe can't be saved yet",
                description: [
                    !selectedIngredientsList?.length && 'Add at least one ingredient.',
                    !preparation_step?.length && 'Add at least one preparation step.',
                ].filter(Boolean).join(' '),
            })
            // wait for the message to render, then bring it into view
            setTimeout(() => {
                document.getElementById(firstErrorId)?.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }, 0)
        }
        if (valid) {
            // const formData = new FormData()
            // formData.append('name', values.name)
            // formData.append('time_for_preparation', values.time_for_preparation)
            // formData.append('serving_size', servingSize)
            // formData.append('recipe_category_id', values.recipe_category)
            // formData.append('recipe_type_id', values.recipe_type)
            // formData.append('kapha', recipePhenoType.includes('Kapha') ? 'Kapha' : '')
            // formData.append('pitta', recipePhenoType.includes('Pitta') ? 'Pitta' : '')
            // formData.append('vata', recipePhenoType.includes('Vata') ? 'Vata' : '')
            // formData.append('recipe_meal_time', arrayOfMealTime)
            // formData.append('recipe_tag_list', arrayOfSelectedDropdownValue)
            // formData.append('recipe_ingredients', selectedIngredientsList)
            // formData.append('recipe_macros_micros', totalMicros)
            // formData.append('preparation_steps', JSON.stringify(preparationSteps))
            // formData.append('recipe_description', values.recipe_description)
            // formData.append('recipe_health_benefits', values.recipe_health_benefits)
            // formData.append('depriciation', depriciation ? '15' : '0')
            // formData.append('status', true)
            // formData.append('image', file)
            // formData.append('image', null)
            const descriptions = preparation_step.map(
                (step) => step.description
            )

            const apiData = {
                name: values.name,
                time_for_preparation: values.time_for_preparation,
                serving_size: servingSize,
                recipe_category_id: values.recipe_category,
                // a recipe can have several types
                recipe_type_ids: values.recipe_type || [],

                kapha: recipePhenoType.includes('Kapha') ? 'Kapha' : '',
                pitta: recipePhenoType.includes('Pitta') ? 'Pitta' : '',
                vata: recipePhenoType.includes('Vata') ? 'Vata' : '',

                recipe_meal_time: arrayOfMealTime,

                recipe_tag_list: arrayOfSelectedDropdownValue,

                recipe_ingredients: selectedIngredientsList,

                //total of all ingredients macros micros array
                recipe_macros_micros: totalMicros,

                preparation_steps: JSON.stringify(descriptions),
                // "preparation_steps": descriptions,
                recipe_description: values.recipe_description,

                recipe_health_benefits: values.recipe_health_benefits,

                depriciation: depriciation ? '15' : '0',

                status: true,

                // "image": file
                image: null,
            }

            // console.log('apiData', apiData);
            // console.log('existRecipeData', existRecipeData);

            // if user update its own created recipe then update it else for other user create a new recipe
            // =============================
            let loginUserId = localStorage.getItem('id')

            // update case
            // ============API CALL COOMENT START
            if (id) {
                // same user id and edit flag is false then update recipe api call (we update our own recipe case)
                // console.log("userId", userId, loginUserId, userId == loginUserId);
                if (userId == loginUserId) {
                    if (existRecipeData?.edit_flag == false) {
                        apiData.edit_flag = false
                        // console.log("1 update", apiData);
                        UpdateRecipe(apiData)
                    }
                    if (existRecipeData?.edit_flag == true) {
                        apiData.edit_flag = true
                        // console.log("2 update", apiData);
                        UpdateRecipe(apiData)
                    }
                }
                if (userId != loginUserId) {
                    // same recipe name is not alowed in recipe if user is diffrent
                    if (
                        compareRecipeNames(existRecipeData?.name, values.name)
                    ) {
                        notification.error({
                            message: 'Same Recipe name is not allowed',
                        })
                        return
                    }

                    // console.log("update by other", existRecipeData);
                    //loginuser and recipe user id doesn't match  and also edit_flag is false then add new recipe
                    if (existRecipeData?.edit_flag == false) {
                        apiData.edit_flag = true

                        // console.log("2 add", apiData);
                        addRecipe(apiData)
                    }
                }
            } else {
                // if (!existRecipeData) {
                apiData.edit_flag = false
                // console.log("1 add", apiData);
                addRecipe(apiData)
                // }
            }
            // ============COOMENT OVER

            // compare the user id
            // if (id && userId == loginUserId) {
            //     updateRecipeApi(id, apiData)
            //         .then((res) => {
            //             if (res.status == 200) {
            //                 notification.success({
            //                     message: "Recipe Updated successfully",
            //                 });
            //                 navigate('/manage-recipe')

            //             }
            //         })
            //         .catch((err) => {
            //             notification.error({
            //                 message: API_ERR_MESSAGE,
            //             });
            //         });
            // } else {
            //     addNewRecipeApi(apiData)
            //         .then((res) => {
            //             if (res.status == 200) {
            //                 notification.success({
            //                     message: "Recipe added successfully",
            //                 });
            //                 navigate('/manage-recipe')
            //             }
            //         })
            //         .catch((err) => {
            //             notification.error({
            //                 message: API_ERR_MESSAGE,
            //             });
            //         });
            // }
        }
    }

    // const addRecipe = (apiData) => {
    //     console.log("add called");
    //     addNewRecipeApi(apiData)
    //         .then((res) => {
    //             if (res.status == 200) {
    //                 notification.success({
    //                     message: "Recipe added successfully",
    //                 });
    //                 navigate('/manage-recipe')
    //             }
    //         })
    //         .catch((err) => {
    //             notification.error({
    //                 message: API_ERR_MESSAGE,
    //             });
    //         });

    // }

    // const UpdateRecipe = (apiData) => {
    //     updateRecipeApi(id, apiData)
    //         .then((res) => {
    //             if (res.status == 200) {
    //                 notification.success({
    //                     message: "Recipe Updated successfully",
    //                 });
    //                 navigate('/manage-recipe')
    //             }
    //         })
    //         .catch((err) => {
    //             notification.error({
    //                 message: API_ERR_MESSAGE,
    //             });
    //         });
    // }

    //

    const addRecipe = (apiData) => {
        console.log('add called')
        setSaving(true)
        axios
            .post(`${BASE_URL}/recipe/add`, apiData, {
                headers: {
                    Authorization: `Bearer ${readAuthCookie('auth_token')}`,
                    'Content-Type': 'application/json',
                },
            })
            .then((res) => {
                if (res.status === 200) {
                    notification.success({
                        message: 'Recipe added successfully',
                    })
                    navigate('/manage-recipe')
                }
            })
            .catch((err) => {
                notification.error({
                    message: apiErrorMessage(err),
                })
            })
            .finally(() => setSaving(false))
    }

    const UpdateRecipe = (apiData) => {
        setSaving(true)
        axios
            .patch(`${BASE_URL}/recipe/${id}`, apiData, {
                headers: {
                    Authorization: `Bearer ${readAuthCookie('auth_token')}`,
                    'Content-Type': 'application/json',
                },
            })
            .then((res) => {
                if (res.status === 200) {
                    notification.success({
                        message: 'Recipe Updated successfully',
                    })
                    navigate('/manage-recipe')
                }
            })
            .catch((err) => {
                notification.error({
                    message: apiErrorMessage(err),
                })
            })
            .finally(() => setSaving(false))
    }
    const resetData = () => {
        form.resetFields()
    }

    // handle preparation steps
    // =================================
    const handlePreparationSteps = (stepData, index, task) => {
        console.log('pp caled')
        if (task == 'add') {
            console.log(JSON.stringify(preparationSteps))
            preparationSteps[index] = stepData
        }
        if (task == 'remove' && preparationSteps?.length > 0) {
            preparationSteps.splice(index, 1)
        }
    }

    // function to display an selected image
    // =================================
    const imagePreview = (e) => {
        const objectUrl = URL.createObjectURL(e.target.files[0])
        setPriviewImg(objectUrl)
        setfile(e.target.files[0])

        // image upload recipe code
        // const formData = new FormData()
        // formData.append('image', e.target.files[0])
        // RecipeImageUploadApi(formData)
        //     .then((res) => {
        //         if (res.status == 200) {
        //             notification.success({
        //                 message: "Image Upload successfully",
        //             });
        //             setRecipeImageUrl(res.data.data)
        //         }
        //     })
        //     .catch((err) => {
        //         notification.error({
        //             message: API_ERR_MESSAGE,
        //         });
        //     });
    }

    // function for insert new ingredient
    // =================================
    const insertData = async () => {
        setIngredientErr('')
        setFormErr('')
        setQuantityErr('')
        setUnitErr('')
        setGramErr('')

        // check Validation Before inserting new ingredient
        let valid = true

        let ingredient = form.getFieldValue('Ingredients')
        let ing_form = form.getFieldValue('form')
        let quantity = form.getFieldValue('quantity')
        let gram = form.getFieldValue('gram')
        // console.log(form.getFieldValue('Ingredients'));
        // console.log("ingredient",ingredient,
        //     "ing_form", ing_form,
        //     "quantity", quantity,
        //     "unit", unit,
        //     gram);

        if (!ingredient) {
            setIngredientErr('Please Select Ingredient')
            valid = false
        }
        if (!ing_form) {
            setFormErr('Please Select Form')
            valid = false
        }
        // if (!unit) {
        //     setUnitErr('Please Select Unit')
        //     valid = false
        // }
        // a number greater than 0 ("0", "0.0" and text are refused)
        if (!isValidIngredientAmount(gram)) {
            // a typed but wrong value already shows the field's own message; only an empty field needs one here
            if (String(gram ?? '').trim() === '') {
                setGramErr(INGREDIENT_AMOUNT_MESSAGE)
            } else {
                form.validateFields(['gram']).catch(() => {})
            }
            valid = false
        }
        // if (!quantity || !quantity.match(NUMBER_AND_FRACTIONAL_PATTERN)) {
        //     setQuantityErr('insert Valid Quantity')
        //     valid = false
        // }
        if (valid) {
            // console.log("insert ingredient called");
            // console.log("ingredientData", ingredientData);
            // console.log(selectedIngredientForm);

            // here get the selected ingredient object and from that object
            // the ingredient raw form has macros micros values so we pass 1 (which is raw form id)

            let a = ingredientData?.form_wise_macros_micros?.find((record) => {
                return record.ingredients_form_id == 1
            })

            // nutrition values are calculated from the raw form, so an ingredient without them can't be added
            if (!a?.ingredient_macros_micros) {
                setIngredientErr(
                    'This ingredient has no raw nutrition values. Add them in Ingredients first.'
                )
                return
            }
            // console.log('a', a);
            // console.log('a==', a?.ingredient_macros_micros);

            // get the object of ingredient form data
            let selectedFormData = ingredientFormOptions.find(
                (element) => element.id == a?.ingredients_form_id
            )

            // console.log("selectedFormData", selectedFormData);
            let MAndMList = [...a.ingredient_macros_micros]

            // user selected ingredient form id
            let selectedIngredientForm = ingredientFormOptions.find(
                (element) => element.id == ing_form
            )

            for (let [index, object] of MAndMList.entries()) {
                // calculate single gram value from 100 gram of macros/micros value and multiply into total ingredient gram value
                //==============================
                // console.log("objkect", object);
                let objectData = { ...object }
                objectData.per_hundred_gram =
                    gram * (objectData.per_hundred_gram / 100)
                // console.log("objectData.per_hundred_gram", objectData.per_hundred_gram);

                // code to decrease the micros value if ingredient form has depriciation percentage
                //======================

                // console.log("percen", selectedFormData.depriciation);
                if (selectedIngredientForm.depriciation > 0) {
                    if (objectData.type == 'Micros') {
                        // console.log("before", objectData.per_hundred_gram);
                        objectData.per_hundred_gram =
                            objectData.per_hundred_gram -
                            (objectData.per_hundred_gram *
                                selectedIngredientForm.depriciation) /
                                100
                        // console.log("after", object.per_hundred_gram);
                    }
                }
                MAndMList[index] = objectData
            }

            let createObjectForAddNewIngredient = {
                ingredient_id: ingredientData?.id,
                ingredient: {
                    name: ingredientData?.name,
                },
                // "ingredients_form_id": a.ingredients_form_id,
                ingredients_form_id: ing_form,
                // "ingredients_form": {
                //     id: a.ingredients_form_id,
                //     name: selectedFormData.name
                // },
                // we insert the ingredient form data which is selected by user
                ingredients_form: {
                    id: ing_form,
                    name: selectedIngredientForm.name,
                },
                quantity: quantity || 1,
                // the unit is the Gram / ml choice (the separate unit field is no longer on the form);
                // the backend links the matching ingredients_unit record
                unit: ingredientMeasurementType,
                ingredient_unit_id: '',
                ingredient_unit: {
                    id: '',
                    name: ingredientMeasurementType,
                },
                gram: form.getFieldValue('gram'),
                gram_type: ingredientMeasurementType,
                // ingredient_macros_micros: macrosMicrosCalc
                ingredient_macros_micros: MAndMList,
            }
            // console.log(createObjectForAddNewIngredient);
            selectedIngredientsList.push(createObjectForAddNewIngredient)

            // clear the form
            form.setFieldsValue({
                Ingredients: '',
                form: '',
                quantity: '',
                unit: '',
                gram: '',
            })

            // setIngredientData()
            // console.log(ingredientsList);
            await findCalculationOfMacrosMicros()
        }
    }

    // function for rmeove ingredient
    // =================================
    const removeIngredients = async (index) => {
        // console.log(index);
        selectedIngredientsList.splice(index, 1)
        findCalculationOfMacrosMicros()
        // console.log(macrosMicrosOptions);
        if (selectedIngredientsList?.length == 0) {
            setTotalMicros(macrosMicrosOptions)
        }
        //   console.log(totalMicros);
    }
    // function for handle all selected ingredients
    // =================================
    const HandleIngredientsList = () => {
        // console.log(form.getFieldValue('serving_size'));
        return (
            selectedIngredientsList &&
            selectedIngredientsList?.length > 0 &&
            selectedIngredientsList.map((element, index) => (
                <Tag key={index}>
                    {element?.quantity} {element?.ingredient?.name} (
                    {element?.gram} {element?.gram_type}) (
                    {element?.ingredients_form?.name})
                    {/* {console.log(element)} */}
                    <Popover
                        key={index}
                        className="IngredientsListItems"
                        content={
                            <>
                                <h5>Macros:</h5>
                                {element?.ingredient_macros_micros &&
                                    element?.ingredient_macros_micros.length >
                                        0 &&
                                    element?.ingredient_macros_micros.map(
                                        (entry, i) =>
                                            // exist code
                                            entry.macros_micros.type ==
                                                'Macros' && (
                                                // (<Tag>{entry?.macros_micros?.name} : {(element?.gram * entry?.per_hundred_gram).toFixed(2)}  {entry?.ingredient_unit_id?.name}</Tag>)
                                                <Tag>
                                                    {entry?.macros_micros?.name}{' '}
                                                    :{' '}
                                                    {parseFloat(
                                                        entry?.per_hundred_gram
                                                    ).toFixed(2)}{' '}
                                                    {entry?.macros_micros?.unit}
                                                </Tag>
                                            )
                                    )}
                                <h5>Micros:</h5>
                                {element?.ingredient_macros_micros &&
                                    element?.ingredient_macros_micros.length >
                                        0 &&
                                    element?.ingredient_macros_micros.map(
                                        (entry, i) =>
                                            // entry.macros_micros.type == 'Micros' && <Tag>{entry?.macros_micros?.name} : {(element?.gram * entry?.per_hundred_gram).toFixed(2)}  {entry?.ingredient_unit_id?.name}</Tag>
                                            // exist code
                                            entry.macros_micros.type ==
                                                'Micros' && (
                                                <Tag>
                                                    {entry?.macros_micros?.name}{' '}
                                                    :{' '}
                                                    {parseFloat(
                                                        entry?.per_hundred_gram
                                                    ).toFixed(2)}{' '}
                                                    {entry?.macros_micros?.unit}
                                                </Tag>
                                            )
                                    )}
                            </>
                        }
                    >
                        <InfoCircleTwoTone className="ms-2 tagIcon" />
                    </Popover>
                    <Popconfirm
                        title="Sure to delete?"
                        className="deleteConfirmPopup"
                        onConfirm={() => removeIngredients(index)}
                    >
                        <CloseCircleFilled className="ms-2 removeIcon" />
                    </Popconfirm>
                </Tag>
            ))
        )
    }

    // function to find values of Total macros and micros of ingredient list
    // =================================
    // const findCalculationOfMacrosMicros = async () => {
    //     // setTimeout(() => {
    //     console.log("selectedIngredientsList", selectedIngredientsList);
    //     // console.log("findCalculationOfMacrosMicros called");
    //     // console.log(totalMicros);
    //     let totalMacrosArray = [];
    //     setTotalMicros([])
    //     // console.log("MacrosMicrosList",MacrosMicrosList)
    //     // setTotalMicros([])
    //     // if (macrosMicrosOptions.length > 0) {
    //     // console.log("come inside");
    //     // selectedIngredientsList.map((element, index) => {
    //     // console.log(selectedIngredientsList?.length)
    //     if (selectedIngredientsList?.length == 0) {
    //         console.log(totalMacrosArray)
    //         console.log("macrosMicrosOptions", macrosMicrosOptions)
    //         macrosMicrosOptions && macrosMicrosOptions.length > 0 && macrosMicrosOptions.map((record) => record.total = 0)
    //         setTotalMicros(macrosMicrosOptions)
    //         console.log("dddd", macrosMicrosOptions);
    //     }

    //     let data = [];
    //     selectedIngredientsList?.length > 0 && selectedIngredientsList.map((element, index) => {
    //         // console.log('element', element);
    //         let total = 0;

    //         // get the selected ingredient form data object to get that form depriciation percentage
    //         // and from that decrease the micros value to given percentage
    //         // let selectedFormData = ingredientFormOptions.find((record) => record.id == element.ingredients_form_id)
    //         console.log("ff", element.ingredient_macros_micros);

    //         element.ingredient_macros_micros.map((e, i) => {

    //             // console.log("totalMacrosArray[i]", totalMacrosArray);
    //             // console.log("eeeee", e);
    //             // ingredient gram * macrod micrs values are per 100 gm so to fing per
    //             // let cal = (element['gram'] * (e['per_hundred_gram'] / 100))
    //             let cal = e['per_hundred_gram']
    //             // console.log(cal);

    //             cal = cal / (servingSize);
    //             // console.log(e.macros_micros['name']);
    //             data[e.macros_micros['name']] = data[e.macros_micros['name']] == undefined ? cal : cal + data[e.macros_micros['name']];
    //             // console.log(macrosMicrosOptions[i].total);
    //             // console.log('e', e);
    //             // MacrosMicrosList[i].total = 0;
    //             // console.log(macrosMicrosOptions[1]?.total);
    //             // console.log('element',element);
    //             // console.log('macros',macrosMicrosOptions[i]);
    //             // element.gram id total gram of ingredient;  e.per_gram_value is each macros,micros unit
    //             // macrosMicrosOptions[i].total = 0
    //             // if (e.id == 2)
    //             //     console.log(element);
    //             // total = (parseFloat(macrosMicrosOptions[i]?.total) || 0) + (parseFloat(element.gram || 0) * parseFloat(e.per_gram_value || 0))

    //             // console.log("MacrosMicrosList", MacrosMicrosList[i]?.total || 0);
    //             // console.log("total", total);
    //             // total = (parseFloat(element.gram) * parseFloat(e.per_gram_value))

    //             // code for depriciation in nutrition value (Applied only in Micros type data)
    //             //============================
    //             if (depriciation) {
    //                 console.log(" data[e.macros_micros['name']]", data[e.macros_micros['name']]);
    //                 if (e.type == 'Macros') {
    //                     macrosMicrosOptions[i].total = data[e.macros_micros['name']];
    //                     totalMacrosArray[i] = macrosMicrosOptions[i];
    //                 }
    //                 // apply depriciation only on Ingredients Total Micros Values
    //                 if (e.type == 'Micros') {
    //                     // if depriciation is true then decrese 15% nutrition value from MICROS
    //                     // macrosMicrosOptions[i].depriciation_total = total - ((total * 15) / 100)
    //                     // macrosMicrosOptions[i].total = total / (servingSize || 1);
    //                     macrosMicrosOptions[i].total = data[e.macros_micros['name']] - ((data[e.macros_micros['name']] * 15) / 100);
    //                     totalMacrosArray[i] = macrosMicrosOptions[i];
    //                 }
    //             } else {
    //                 // recipe total macros divide by the no person to get per person nutrition value
    //                 // macrosMicrosOptions[i].total = total / (servingSize || 1);
    //                 // console.log(data[e['name']]);
    //                 // if (macrosMicrosOptions.length > 0) {
    //                 // console.log("aaa");
    //                 // console.log(macrosMicrosOptions);
    //                 macrosMicrosOptions[i].total = data[e.macros_micros['name']];
    //                 totalMacrosArray[i] = macrosMicrosOptions[i];
    //                 // }
    //             }
    //         })
    //     })

    //     // console.log('macrosMicrosOptions[i]',macrosMicrosOptions[i]);
    //     //    console.log(selectedIngredientsList)
    //     console.log("totalMacrosArray", totalMacrosArray)
    //     setTotalMicros(totalMacrosArray)
    //     // }

    //     //   console.log('totalMacrosArray', totalMacrosArray);
    //     // console.log("totalMicros", JSON.stringify(totalMicros))
    //     //   console.log("totalMacrosArray", totalMacrosArray)
    //     setFlag(!flag)
    //     // }, 3000)

    // }
    // chat gpt code  for above  funtion
    const findCalculationOfMacrosMicros = async () => {
        console.log('selectedIngredientsList ====', selectedIngredientsList)
        try {
            let totalMacrosArray = []

            // Clear total micros initially
            setTotalMicros([])

            // If no ingredients selected, reset all totals to zero
            if (
                selectedIngredientsList &&
                selectedIngredientsList?.length === 0
            ) {
                const resetOptions = macrosMicrosOptions.map((record) => ({
                    ...record,
                    total: 0,
                }))
                setTotalMicros(resetOptions)
                return // No need to proceed further
            }
            let data = []
            // Iterate through selected ingredients
            selectedIngredientsList &&
                selectedIngredientsList?.length > 0 &&
                selectedIngredientsList.forEach((element) => {
                    // Calculate total for each ingredient

                    element?.ingredient_macros_micros &&
                        element?.ingredient_macros_micros?.length > 0 &&
                        element?.ingredient_macros_micros.forEach((e) => {
                            let cal = e.per_hundred_gram / servingSize

                            // Initialize data if not already
                            data[e.macros_micros.name] =
                                data[e.macros_micros.name] || 0
                            data[e.macros_micros.name] += cal

                            // Apply depreciation if needed
                            if (depriciation && e.type === 'Micros') {
                                data[e.macros_micros.name] -=
                                    (data[e.macros_micros.name] * 15) / 100
                            }
                        })
                })

            // Prepare totalMacrosArray from data
            totalMacrosArray = macrosMicrosOptions.map((option) => ({
                ...option,
                total: data[option.name] || 0,
            }))

            // Set the state with updated totals
            setTotalMicros(totalMacrosArray)
            console.log('totalMacrosArray', totalMacrosArray)

            // Update flag to trigger re-render
            setFlag(!flag)
        } catch (error) {
            console.error('Error in calculating macros and micros:', error)
        }
    }

    // Apis For DropDown Data
    // =============================
    const getListOfRecipeCategories = () => {
        setLoading(true)
        listOfRecipeCategoriesApi()
            .then((res) => {
                if (res.status === 200) {
                    setCategoryOptions(FilterApiData(res.data.data))
                }
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                })
            })
    }

    const getListOfIngredientForms = () => {
        listOfIngredientFormApi()
            .then((res) => {
                if (res.status === 200) {
                    setingredientFormOptions(FilterApiData(res.data.data))
                }
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                })
            })
    }

    const getListOfRecipeTypes = () => {
        listOfRecipeTypesApi()
            .then((res) => {
                if (res.status === 200) {
                    setRecipetypeOptions(FilterApiData(res.data.data))
                }
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                })
            })
    }
    const getListOfMealTime = () => {
        listOfMealTimeApi()
            .then((res) => {
                if (res.status === 200) {
                    setMealTimeOptions(FilterApiData(res.data.data))
                }
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                })
            })
    }

    // get the list of alll Recipe Tags
    const getListOfRecipeTags = () => {
        listOfRecipeTagsApi()
            .then((res) => {
                if (res.status === 200) {
                    setRecipeTagsOptions(FilterApiData(res.data.data))
                }
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                })
            })
    }

    const getListOfDiseases = () => {
        listOfDiseasesApi()
            .then((res) => {
                if (res.status === 200) {
                    setDiseasesOptions(FilterApiData(res.data.data))
                }
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                })
            })
    }
    const getlistOfIngredientUnit = () => {
        listOfIngredientUnitApi()
            .then((res) => {
                if (res.status === 200) {
                    setingredientUnitOptions(FilterApiData(res.data.data))
                    setLoading(false)
                }
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                })
            })
    }

    useEffect(() => {
        findCalculationOfMacrosMicros()
    }, [servingSize, depriciation])

    // on page load when macrosMicrosOptions is set then called findcalculation function
    // ====================================
    useEffect(() => {
        findCalculationOfMacrosMicros()
    }, [macrosMicrosOptions])
    useEffect(() => {
        findCalculationOfMacrosMicros()
    }, [selectedIngredientsList])

    useEffect(() => {
        getListOfMacrosMicros()
        setHeaderName(id ? 'Edit Recipe' : 'Add Recipe')
        setServingSize(1)
        setTotalMicros(macrosMicrosOptions)
        setFlag(!flag)

        // handlePreparationSteps('', 0, 'add')

        // dropdown data apis call
        // ===================
        getListOfRecipeCategories()
        getListOfRecipeTypes()
        getListOfMealTime()
        getListOfRecipeTags()
        getListOfDiseases()
        getListOfIngredients()
        getListOfIngredientForms()
        getlistOfIngredientUnit()

        // if the id is available then we need update recipe so fill all the recipe data in form
        // =====================================================

        // correct and working code start
        if (id) {
            editRecipeApi(id)
                .then((res) => {
                    if (res.status === 200) {
                        let recipeData = res.data.data
                        setExistRecipeData(res.data.data)

                        setDepriciation(
                            recipeData?.depriciation == 0 ? false : true
                        )
                        console.log('recipeData', recipeData)
                        form.setFieldsValue({
                            time_for_preparation:
                                recipeData?.time_for_preparation,
                            serving_size: recipeData?.serving_size,
                            name: recipeData?.name,
                            recipe_category: recipeData?.recipe_category_id,
                            recipe_type: (recipeData?.recipe_types || []).map((type) => type.id),
                            recipe_description: recipeData?.recipe_description,
                            recipe_health_benefits:
                                recipeData?.recipe_health_benefits,

                            // set the preaparation steps
                            // "preparation_steps": JSON.parse(recipeData?.preparation_steps)
                        })
                        // console.log(JSON.parse(recipeData?.preparation_steps))

                        // set user id
                        setUserId(recipeData?.user?.id)

                        setArrayOfMealTime(recipeData?.recipe_meal_time)
                        // set the selected Recipe Pheno type
                        //=======================================================
                        let temp_phenotyoe = []

                        if (recipeData?.kapha !== '') {
                            // temp_phenotyoe.push(recipeData?.kapha)
                            temp_phenotyoe.push('Kapha')
                        }
                        if (recipeData?.pitta !== '') {
                            // temp_phenotyoe.push(recipeData?.pitta)
                            temp_phenotyoe.push('Pitta')
                        }
                        if (recipeData?.vata !== '') {
                            // temp_phenotyoe.push(recipeData?.vata)
                            temp_phenotyoe.push('Vata')
                        }
                        form.setFieldsValue({
                            recipe_pheno_type: temp_phenotyoe,
                        })
                        setRecipePhenoType(temp_phenotyoe)

                        // set the selected ingredients array
                        //=======================================================
                        // ACTUAL AND EXIST CODE
                        // setSelectedIngredientsList(recipeData?.recipe_ingredient)
                        setSelectedIngredientsList([])

                        // TEST ANOTHER TO FILL DATA
                        const ingreData = []
                        if (
                            recipeData?.recipe_ingredient &&
                            recipeData?.recipe_ingredient?.length > 0
                        ) {
                            // recipeData?.recipe_ingredient?.map(ingredientRecord => {
                            //     console.log("ingredientRecord?.recipe_ingredient_macros_micros", ingredientRecord);
                            //     const uniqueIngredients = ingredientRecord?.ingredient_macros_micros.filter((ingredient, index, self) =>
                            //         index === self.findIndex((t) => (
                            //             t.macros_micros_id === ingredient.macros_micros_id
                            //         ))
                            //     );
                            //     const createObjectForAddNewIngredient = {
                            //         'ingredient_id': ingredientRecord?.ingredient_id,
                            //         'ingredient': {
                            //             name: ingredientRecord?.ingredient?.name
                            //         },
                            //         "ingredients_form_id": ingredientRecord?.ingredients_form_id,
                            //         "ingredients_form": {
                            //             id: ingredientRecord?.ingredients_form_id,
                            //             name: ingredientRecord?.ingredients_form?.name
                            //         },
                            //         quantity: ingredientRecord?.quantity,
                            //         unit: ingredientRecord?.unit,
                            //         ingredient_unit_id: ingredientRecord?.ingredient_unit_id,
                            //         ingredient_unit: {
                            //             id: ingredientRecord?.ingredient_unit_id,
                            //             name: ingredientRecord?.ingredient_unit?.name
                            //         },
                            //         gram: ingredientRecord?.gram,
                            //         gram_type: ingredientRecord?.gram_type,
                            //         ingredient_macros_micros: uniqueIngredients
                            //     }
                            //     ingreData?.push(createObjectForAddNewIngredient)
                            // }
                            // )
                            // test code

                            recipeData?.ingredient_macros_micros?.map(
                                (dataRecord, ingIndex) => {
                                    console.log(
                                        'dataRecord?.recipe_ingredient_macros_micros',
                                        dataRecord
                                    )
                                    let uniqueIngredients = dataRecord?.data
                                    let ingredientRecord =
                                        recipeData?.recipe_ingredient?.find(
                                            (reco) =>
                                                reco?.ingredient_id ==
                                                dataRecord?.ingredient_id
                                        )

                                    const createObjectForAddNewIngredient = {
                                        ingredient_id:
                                            ingredientRecord?.ingredient_id,
                                        ingredient: {
                                            name: ingredientRecord?.ingredient
                                                ?.name,
                                        },
                                        ingredients_form_id:
                                            ingredientRecord?.ingredients_form_id,
                                        ingredients_form: {
                                            id: ingredientRecord?.ingredients_form_id,
                                            name: ingredientRecord
                                                ?.ingredients_form?.name,
                                        },
                                        quantity: ingredientRecord?.quantity,
                                        unit: ingredientRecord?.unit,
                                        ingredient_unit_id:
                                            ingredientRecord?.ingredient_unit_id,
                                        ingredient_unit: {
                                            id: ingredientRecord?.ingredient_unit_id,
                                            name: ingredientRecord
                                                ?.ingredient_unit?.name,
                                        },
                                        gram: ingredientRecord?.gram,
                                        gram_type: ingredientRecord?.gram_type,
                                        ingredient_macros_micros:
                                            uniqueIngredients,
                                    }
                                    ingreData?.push(
                                        createObjectForAddNewIngredient
                                    )
                                }
                            )
                            console.log('ingreData', ingreData)
                            setSelectedIngredientsList(ingreData)
                        }
                        // TEST ANOTHER TO FILL DATA  OVER

                        console.log(
                            'recipeData?.recipe_ingredient',
                            recipeData?.recipe_ingredient
                        )

                        // In below code we get the list of all recipe tags array then we categorize the selected tags from its tag type and get the
                        // array of that ids and then fill the values in form
                        //=======================================================
                        const temp = [
                            {
                                fieldName: 'type_of_diet_tag',
                                tag_type: 'Type of Diet Tags',
                            },
                            {
                                fieldName: 'cooking_method_tag',
                                tag_type: 'Recipe by Cooking Method Tags',
                            },
                            {
                                fieldName: 'recipe_by_season_tag',
                                tag_type: 'Recipe by seasons Tags',
                            },
                            {
                                fieldName: 'recipe_difficulty_level_tag',
                                tag_type: 'Recipe by difficulty level Tags',
                            },
                            { fieldName: 'other_tag', tag_type: 'Other Tags' },
                            {
                                fieldName: 'allergy_tag',
                                tag_type: 'Allergy Tags',
                            },
                            {
                                fieldName: 'disease_tag',
                                tag_type: 'Disease Tags',
                            },
                            {
                                fieldName: 'nutrient_tags',
                                tag_type: 'Nutrient Tags',
                            },
                            {
                                fieldName: 'cuisine_tags',
                                tag_type: 'Cuisine Tags',
                            },
                            { fieldName: 'goal_tag', tag_type: 'Goal Tags' },
                        ]

                        if (
                            recipeData?.recipe_tag_list &&
                            recipeData?.recipe_tag_list?.length > 0
                        ) {
                            temp.map((record) =>
                                form.setFieldsValue({
                                    [record.fieldName]:
                                        recipeData?.recipe_tag_list
                                            ?.filter(
                                                (element) =>
                                                    element.recipe_tag
                                                        .tagType ==
                                                    record.tag_type
                                            )
                                            .map((a) => a.recipe_tag_id),
                                })
                            )
                        }

                        setArrayOfSelectedDropdownValue(
                            recipeData?.recipe_tag_list
                        )

                        // set the meal time
                        //=======================================================
                        form.setFieldsValue({
                            meal_time: recipeData?.recipe_meal_time.map(
                                (a) => a.meal_time_id
                            ),
                        })

                        // set the preparationsteps
                        //=======================================================

                        setPreparationSteps(
                            JSON.parse(recipeData?.preparation_steps)
                        )
                        // form.setFieldValue('preparation_steps', JSON.parse(recipeData?.preparation_steps))
                        const preparationStepsData = JSON.parse(
                            recipeData?.preparation_steps
                        )
                        if (
                            preparationStepsData &&
                            preparationStepsData?.length > 0
                        ) {
                            form.setFieldsValue({
                                preparation_steps: preparationStepsData.map(
                                    (step, index) => ({ description: step })
                                ),
                            })
                        }
                        // // Set form field values using form.setFieldValue
                        // preparationStepsData.forEach((step, index) => {
                        //     form.setFieldsValue({
                        //         [`preparation_steps[${index}]`]: step
                        //     });
                        // });
                        findCalculationOfMacrosMicros()
                    }
                })
                .catch((err) => {
                    console.log('err', err)
                    notification.error({
                        message: API_ERR_MESSAGE,
                    })
                })
        }
        // correct and working code over
    }, [])

    const [optionsSelected, setOptionsSelected] = useState([])

    const handleChange = (value) => {
        //   console.log(`selected ${value}`);
        setOptionsSelected(value)
    }

    const validateSpecialCharacters = (_, value) => {
        const regex = /^[A-Za-z_\- ]+$/ // Regular expression to allow characters, underscores, hyphens, and spaces
        if (!regex.test(value)) {
            return Promise.reject(
                'Only characters, underscores, and hyphens are allowed.'
            )
        }
        return Promise.resolve()
    }

    return (
        <div className="AddOrEditRecipe">
            <Spin spinning={loading} className="spinner-code">
                <Form
                    name="AddOrEditRecipeForm"
                    className="AddOrEditRecipeForm"
                    form={form}
                    onFinish={onFinish}
                    // a field error (e.g. a taken name) scrolls into view instead of failing silently
                    scrollToFirstError={{ behavior: 'smooth', block: 'center' }}
                >
                    <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 8 }]}>
                        <Col xs={24} md={12} xl={6} xxl={6}>
                            <label className="form-input-label">
                                Recipe Name
                                <span className="asterik"> *</span>
                            </label>
                            <Form.Item
                                name="name"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please Enter Name!',
                                    },
                                    // {
                                    //     pattern: CHARACTER_PATTERN,
                                    //     message: CHARACTER_PATTERN_MESSAGE,
                                    // },
                                    {
                                        validator: validateSpecialCharacters,
                                    },
                                    {
                                        // tell the user about a taken name when they leave the field, not only on save
                                        validateTrigger: 'onBlur',
                                        validator: validateNameAvailable,
                                    },
                                ]}
                                validateTrigger={['onChange', 'onBlur']}
                            >
                                <Input
                                    placeholder="Enter Name"
                                    className="mt-2 p-2"
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12} xl={6} xxl={6}>
                            <label className="form-input-label">
                                Time for preparation
                                <span className="asterik"> *</span>
                            </label>
                            <Form.Item
                                name="time_for_preparation"
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            'Please Enter Time for preparation!',
                                    },
                                ]}
                                initialValue=""
                            >
                                <Select
                                    className="mt-2"
                                    // value={regType}
                                    // onChange={(e) => setRegType(e)}
                                >
                                    <Option value="" disabled hidden>
                                        Select Time for preparation
                                    </Option>
                                    <Option value="5 min">5 min</Option>
                                    <Option value="10 min">10 min</Option>
                                    <Option value="15 min">15 min</Option>
                                    <Option value="20 min">20 min</Option>
                                    <Option value="25 min">25 min</Option>
                                    <Option value="30 min">30 min</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12} xl={6} xxl={6}>
                            <label className="form-input-label">
                                Select Serving Size
                                <span className="asterik"> *</span>
                            </label>
                            <Form.Item
                                name="serving_size"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Select Serving Size!',
                                    },
                                ]}
                                initialValue="1"
                            >
                                <Select
                                    className="mt-2"
                                    // value={regType}
                                    // defaultValue="1"
                                    onChange={(e) => setServingSize(e)}
                                >
                                    <Option value="" disabled hidden>
                                        Select Serving Size
                                    </Option>
                                    <Option value="1">1</Option>
                                    <Option value="2">2</Option>
                                    <Option value="3">3</Option>
                                    <Option value="4">4</Option>
                                    <Option value="5">5</Option>
                                    <Option value="6">6</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12} xl={6} xxl={6}>
                            <label className="form-input-label">
                                Recipe Category
                                <span className="asterik"> *</span>
                            </label>
                            <Form.Item
                                name="recipe_category"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Select Recipe Category!',
                                    },
                                ]}
                                initialValue=""
                            >
                                <Select
                                    className="mt-2"
                                    // value={regType}
                                    // defaultValue=""
                                    // onChange={(e) => setRegType(e)}
                                >
                                    <Option value="" disabled hidden>
                                        Select Recipe Category
                                    </Option>
                                    {categoryOptions &&
                                        categoryOptions?.length > 0 &&
                                        categoryOptions.map((element) => (
                                            <Option
                                                key={element.id}
                                                value={element.id}
                                            >
                                                {element.name}
                                            </Option>
                                        ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12} xl={6} xxl={6}>
                            <label className="form-input-label">
                                Recipe Type
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="recipe_type"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please Select Recipe Type!',
                                    },
                                ]}
                                initialValue={[]}
                            >
                                <Select
                                    className="mt-2"
                                    // a recipe can have several types
                                    mode="multiple"
                                    showSearch
                                    optionFilterProp="children"
                                    placeholder="Select Recipe Type"
                                >
                                    {recipetypeOptions?.length > 0 &&
                                        recipetypeOptions.map((element) => (
                                            <Option
                                                key={element.id}
                                                value={element.id}
                                            >
                                                {element.name}
                                            </Option>
                                        ))}

                                    {/* <Option value="Grains">Grains</Option>
                                <Option value="Protein">Protein</Option>
                                <Option value="Cooked Vegetables">Cooked Vegetables</Option>
                                <Option value="Fruits">Fruits</Option>
                                <Option value="Salad">Salad</Option> */}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12} xl={6} xxl={6}>
                            <label className="form-input-label">
                                Recipe Phenotype
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            {/* optional: a recipe can have no phenotype */}
                            <Form.Item name="recipe_pheno_type">
                                <Checkbox.Group
                                    onChange={(e) => setRecipePhenoType(e)}
                                >
                                    <Checkbox value="Vata">Vata</Checkbox>
                                    <Checkbox value="Pitta">Pitta</Checkbox>
                                    <Checkbox value="Kapha">Kapha</Checkbox>
                                </Checkbox.Group>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={24} lg={24} xl={12} xxl={12}>
                            <label className="form-input-label">
                                Meal Time
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="meal_time"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please Select Mealtime!',
                                    },
                                ]}
                            >
                                <Checkbox.Group
                                    onChange={(e) => CreateArrayOfMealTime(e)}
                                >
                                    {mealTimeOptions?.length > 0 &&
                                        mealTimeOptions.map((element) => (
                                            <Checkbox
                                                key={element?.id}
                                                value={element?.id}
                                            >
                                                {element.name}
                                            </Checkbox>
                                        ))}
                                    {/* <Checkbox value="Mid Morning">Mid Morning</Checkbox>
                                <Checkbox value="Lunch">Lunch</Checkbox>
                                <Checkbox value="Evening">Evening</Checkbox>
                                <Checkbox value="Dinner">Dinner</Checkbox> */}
                                </Checkbox.Group>
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={24} lg={24} xl={24} xxl={24}>
                            <label className="form-input-label">
                                Select Recipe Tags:
                                {/* <span className="asterik"> *</span> */}
                            </label>
                        </Col>
                        <Col xs={24} md={12} xl={6} xxl={6}>
                            <Form.Item
                                name="nutrient_tags"
                                rules={[
                                    {
                                        required: false,
                                        message: 'Please Select Nutrient Tags!',
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="Select Nutrient Tags"
                                    allowClear
                                    showSearch
                                    onSelect={(e) =>
                                        CreateArrayOfSelectedValue(e, 'add')
                                    }
                                    onDeselect={(e) =>
                                        CreateArrayOfSelectedValue(e, 'remove')
                                    }
                                    filterOption={(inputValue, option) =>
                                        option.children
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase())
                                    }
                                    maxTagCount="responsive"
                                    // maxLength={2}
                                    maxLength="2"
                                    mode="multiple"
                                >
                                    {recipeTagsOptions &&
                                        recipeTagsOptions?.length > 0 &&
                                        recipeTagsOptions.map(
                                            (element) =>
                                                element.tagType ==
                                                    'Nutrient Tags' && (
                                                    <Option
                                                        disabled={
                                                            optionsSelected?.length >
                                                            1
                                                                ? optionsSelected.includes(
                                                                      element
                                                                  )
                                                                    ? false
                                                                    : true
                                                                : false
                                                        }
                                                        key={element.id}
                                                        value={element.id}
                                                    >
                                                        {element.name}
                                                    </Option>
                                                )
                                        )}
                                    {/* {NutrientTagsOptions.map(option => (
                                    <Option disabled={
                                        optionsSelected?.length > 1
                                            ? optionsSelected.includes(option)
                                                ? false
                                                : true
                                            : false
                                    } key={option.id}>{option.name}</Option>
                                ))} */}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12} xl={6} xxl={6}>
                            <Form.Item
                                name="cuisine_tags"
                                rules={[
                                    {
                                        required: false,
                                        message: 'Please Select Cuisine Tags!',
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="Select Cuisine Tags"
                                    allowClear
                                    showSearch
                                    // onChange={handleChange}
                                    onSelect={(e) =>
                                        CreateArrayOfSelectedValue(e, 'add')
                                    }
                                    onDeselect={(e) =>
                                        CreateArrayOfSelectedValue(e, 'remove')
                                    }
                                    filterOption={(inputValue, option) =>
                                        option.children
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase())
                                    }
                                    maxTagCount="responsive"
                                    // maxLength={2}
                                    // maxLength="2"
                                    mode="multiple"
                                >
                                    {recipeTagsOptions?.length > 0 &&
                                        recipeTagsOptions.map(
                                            (element) =>
                                                element.tagType ==
                                                    'Cuisine Tags' && (
                                                    <Option
                                                        // disabled={
                                                        //     optionsSelected?.length > 1
                                                        //         ? optionsSelected.includes(element)
                                                        //             ? false
                                                        //             : true
                                                        //         : false
                                                        // }
                                                        key={element.id}
                                                        value={element.id}
                                                    >
                                                        {element.name}
                                                    </Option>
                                                )
                                        )}
                                    {/* {CuisineTagsOptions.map(option => (
                                    <Option disabled={
                                        optionsSelected?.length > 1
                                            ? optionsSelected.includes(option)
                                                ? false
                                                : true
                                            : false
                                    } key={option.id}>{option.name}</Option>
                                ))} */}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12} xl={6} xxl={6}>
                            <Form.Item
                                name="type_of_diet_tag"
                                rules={[
                                    {
                                        required: false,
                                        message:
                                            'Please Select Type Of Diet Tags!',
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="Select Type Of Diet Tags"
                                    allowClear
                                    showSearch
                                    filterOption={(inputValue, option) =>
                                        option.children
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase())
                                    }
                                    onSelect={(e) =>
                                        CreateArrayOfSelectedValue(e, 'add')
                                    }
                                    onDeselect={(e) =>
                                        CreateArrayOfSelectedValue(e, 'remove')
                                    }
                                    maxTagCount="responsive"
                                    // maxLength={2}
                                    mode="multiple"
                                >
                                    {recipeTagsOptions?.length > 0 &&
                                        recipeTagsOptions.map(
                                            (element) =>
                                                element.tagType ==
                                                    'Type of Diet Tags' && (
                                                    <Option
                                                        // disabled={
                                                        //     optionsSelected?.length > 1
                                                        //         ? optionsSelected.includes(element)
                                                        //             ? false
                                                        //             : true
                                                        //         : false
                                                        // }
                                                        key={element.id}
                                                        value={element.id}
                                                    >
                                                        {element.name}
                                                    </Option>
                                                )
                                        )}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12} xl={6} xxl={6}>
                            <Form.Item
                                name="cooking_method_tag"
                                rules={[
                                    {
                                        required: false,
                                        message:
                                            'Please Select Cooking Method Tags!',
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="Select Recipe by Cooking Method Tags"
                                    allowClear
                                    showSearch
                                    onChange={handleChange}
                                    filterOption={(inputValue, option) =>
                                        option.children
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase())
                                    }
                                    onSelect={(e) =>
                                        CreateArrayOfSelectedValue(e, 'add')
                                    }
                                    onDeselect={(e) =>
                                        CreateArrayOfSelectedValue(e, 'remove')
                                    }
                                    maxTagCount="responsive"
                                    // maxLength={2}
                                    mode="multiple"
                                >
                                    {recipeTagsOptions?.length > 0 &&
                                        recipeTagsOptions.map(
                                            (element) =>
                                                element.tagType ==
                                                    'Recipe by Cooking Method Tags' && (
                                                    <Option
                                                        // disabled={
                                                        //     optionsSelected?.length > 1
                                                        //         ? optionsSelected.includes(element)
                                                        //             ? false
                                                        //             : true
                                                        //         : false
                                                        // }
                                                        key={element.id}
                                                        value={element.id}
                                                    >
                                                        {element.name}
                                                    </Option>
                                                )
                                        )}
                                    {/* {CuisineTagsOptions.map(option => (
                                    <Option disabled={
                                        optionsSelected?.length > 1
                                            ? optionsSelected.includes(option)
                                                ? false
                                                : true
                                            : false
                                    } key={option.id}>{option.name}</Option>
                                ))} */}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12} xl={8} xxl={8}>
                            <Form.Item
                                name="recipe_by_season_tag"
                                rules={[
                                    {
                                        required: false,
                                        message:
                                            'Please Select Recipe By Season Tags!',
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="Select Recipe by Season Tags"
                                    allowClear
                                    showSearch
                                    onChange={handleChange}
                                    filterOption={(inputValue, option) =>
                                        option.children
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase())
                                    }
                                    maxTagCount="responsive"
                                    mode="multiple"
                                    onSelect={(e) =>
                                        CreateArrayOfSelectedValue(e, 'add')
                                    }
                                    onDeselect={(e) =>
                                        CreateArrayOfSelectedValue(e, 'remove')
                                    }
                                >
                                    {recipeTagsOptions?.length > 0 &&
                                        recipeTagsOptions.map(
                                            (element) =>
                                                element.tagType ==
                                                    'Recipe by seasons Tags' && (
                                                    <Option
                                                        // disabled={
                                                        //     optionsSelected?.length > 2
                                                        //         ? optionsSelected.includes(element)
                                                        //             ? false
                                                        //             : true
                                                        //         : false
                                                        // }
                                                        key={element.id}
                                                        value={element.id}
                                                    >
                                                        {element.name}
                                                    </Option>
                                                )
                                        )}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12} xl={8} xxl={8}>
                            <Form.Item
                                name="recipe_difficulty_level_tag"
                                rules={[
                                    {
                                        required: false,
                                        message:
                                            'Please Select Recipe Difficulty Level Tags!',
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="Select Recipe by difficulty level Tags"
                                    allowClear
                                    showSearch
                                    onChange={handleChange}
                                    filterOption={(inputValue, option) =>
                                        option.children
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase())
                                    }
                                    maxTagCount="responsive"
                                    mode="multiple"
                                    onSelect={(e) =>
                                        CreateArrayOfSelectedValue(e, 'add')
                                    }
                                    onDeselect={(e) =>
                                        CreateArrayOfSelectedValue(e, 'remove')
                                    }
                                >
                                    {recipeTagsOptions?.length > 0 &&
                                        recipeTagsOptions.map(
                                            (element) =>
                                                element.tagType ==
                                                    'Recipe by difficulty level Tags' && (
                                                    <Option
                                                        // disabled={
                                                        //     optionsSelected?.length > 1
                                                        //         ? optionsSelected.includes(element)
                                                        //             ? false
                                                        //             : true
                                                        //         : false
                                                        // }
                                                        key={element.id}
                                                        value={element.id}
                                                    >
                                                        {element.name}
                                                    </Option>
                                                )
                                        )}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12} xl={8} xxl={8}>
                            <Form.Item
                                name="other_tag"
                                rules={[
                                    {
                                        required: false,
                                        message: 'Please Select Other Tags!',
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="Select Other Tags"
                                    allowClear
                                    showSearch
                                    onChange={handleChange}
                                    filterOption={(inputValue, option) =>
                                        option.children
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase())
                                    }
                                    maxTagCount="responsive"
                                    mode="multiple"
                                    onSelect={(e) =>
                                        CreateArrayOfSelectedValue(e, 'add')
                                    }
                                    onDeselect={(e) =>
                                        CreateArrayOfSelectedValue(e, 'remove')
                                    }
                                >
                                    {recipeTagsOptions?.length > 0 &&
                                        recipeTagsOptions.map(
                                            (element) =>
                                                element.tagType ==
                                                    'Other Tags' && (
                                                    <Option
                                                        //  disabled={
                                                        //     optionsSelected?.length > 1
                                                        //         ? optionsSelected.includes(element)
                                                        //             ? false
                                                        //             : true
                                                        //         : false
                                                        // }
                                                        key={element.id}
                                                        value={element.id}
                                                    >
                                                        {element.name}
                                                    </Option>
                                                )
                                        )}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12} xl={8} xxl={8}>
                            <label className="form-input-label">
                                Select Allergy Tags:
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="allergy_tag"
                                rules={[
                                    {
                                        required: false,
                                        message: 'Please Select Allergy Tags!',
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="Select Allergy present in This Recipe"
                                    allowClear
                                    showSearch
                                    onChange={handleChange}
                                    filterOption={(inputValue, option) =>
                                        option.children
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase())
                                    }
                                    maxTagCount="responsive"
                                    mode="multiple"
                                    onSelect={(e) =>
                                        CreateArrayOfSelectedValue(e, 'add')
                                    }
                                    onDeselect={(e) =>
                                        CreateArrayOfSelectedValue(e, 'remove')
                                    }
                                >
                                    {recipeTagsOptions?.length > 0 &&
                                        recipeTagsOptions.map(
                                            (element) =>
                                                element.tagType ==
                                                    'Allergy Tags' && (
                                                    <Option
                                                        // disabled={
                                                        //     optionsSelected?.length > 1
                                                        //         ? optionsSelected.includes(element)
                                                        //             ? false
                                                        //             : true
                                                        //         : false
                                                        // }
                                                        key={element.id}
                                                        value={element.id}
                                                    >
                                                        {element.name}
                                                    </Option>
                                                )
                                        )}
                                    {/* {CuisineTagsOptions.map(option => (
                                    <Option disabled={
                                        optionsSelected?.length > 1
                                            ? optionsSelected.includes(option)
                                                ? false
                                                : true
                                            : false
                                    } key={option.id}>{option.name}</Option>
                                ))} */}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12} xl={8} xxl={8}>
                            <label className="form-input-label">
                                Select Disease Tags:
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="disease_tag"
                                rules={[
                                    {
                                        required: false,
                                        message: 'Please Select Disease Tags!',
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="Select Diseases for which this Recipe is NOT recommanded"
                                    allowClear
                                    showSearch
                                    onChange={handleChange}
                                    filterOption={(inputValue, option) =>
                                        option.children
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase())
                                    }
                                    maxTagCount="responsive"
                                    mode="multiple"
                                    onSelect={(e) =>
                                        CreateArrayOfSelectedValue(e, 'add')
                                    }
                                    onDeselect={(e) =>
                                        CreateArrayOfSelectedValue(e, 'remove')
                                    }
                                >
                                    {recipeTagsOptions?.length > 0 &&
                                        recipeTagsOptions.map(
                                            (element) =>
                                                element.tagType ==
                                                    'Disease Tags' && (
                                                    <Option
                                                        // disabled={
                                                        //     optionsSelected?.length > 1
                                                        //         ? optionsSelected.includes(element)
                                                        //             ? false
                                                        //             : true
                                                        //         : false
                                                        // }
                                                        key={element.id}
                                                        value={element.id}
                                                    >
                                                        {element.name}
                                                    </Option>
                                                )
                                        )}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12} xl={8} xxl={8}>
                            <label className="form-input-label">
                                Select Goal Tags:
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="goal_tag"
                                rules={[
                                    {
                                        required: false,
                                        message: 'Please Select Goal Tags!',
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="Select Goal for which this Recipe is recomanded"
                                    allowClear
                                    showSearch
                                    onChange={handleChange}
                                    filterOption={(inputValue, option) =>
                                        option.children
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase())
                                    }
                                    maxTagCount="responsive"
                                    mode="multiple"
                                    onSelect={(e) =>
                                        CreateArrayOfSelectedValue(e, 'add')
                                    }
                                    onDeselect={(e) =>
                                        CreateArrayOfSelectedValue(e, 'remove')
                                    }
                                >
                                    {recipeTagsOptions?.length > 0 &&
                                        recipeTagsOptions.map(
                                            (element) =>
                                                element.tagType ==
                                                    'Goal Tags' && (
                                                    <Option
                                                        // disabled={
                                                        //     optionsSelected?.length > 1
                                                        //         ? optionsSelected.includes(element)
                                                        //             ? false
                                                        //             : true
                                                        //         : false
                                                        // }
                                                        key={element.id}
                                                        value={element.id}
                                                    >
                                                        {element.name}
                                                    </Option>
                                                )
                                        )}
                                    {/* {CuisineTagsOptions.map(option => (
                                    <Option disabled={
                                        optionsSelected?.length > 1
                                            ? optionsSelected.includes(option)
                                                ? false
                                                : true
                                            : false
                                    } key={option.id}>{option.name}</Option>
                                ))} */}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={24} xl={24} xxl={24}>
                            <label className="form-input-label">
                                Add Ingredients:
                                {/* <span className="asterik"> *</span> */}
                            </label>
                        </Col>
                        <Col xs={24} md={24} xl={8} xxl={8}>
                            <Form.Item
                                name="Ingredients"
                                // rules={[
                                //     { required: true, message: "Please Select Ingredients!" },
                                // ]}
                            >
                                <Select
                                    placeholder="Select Ingredients"
                                    allowClear
                                    showSearch
                                    onChange={(e) =>
                                        setIngredientData(
                                            ingredientsList.find(
                                                (record) => record.id == e
                                            )
                                        )
                                    }
                                    filterOption={(inputValue, option) =>
                                        option.children
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase())
                                    }
                                >
                                    <Option value="" disabled hidden>
                                        Select Ingredient
                                    </Option>
                                    {ingredientsList &&
                                        ingredientsList?.length > 0 &&
                                        ingredientsList.map((option) => (
                                            <Option key={option.id}>
                                                {option.name}
                                            </Option>
                                        ))}
                                </Select>
                            </Form.Item>
                            <label className="text-danger">
                                {ingredientErr}
                            </label>
                        </Col>
                        <Col xs={24} md={6} xl={4} xxl={4}>
                            <Form.Item
                                name="form"
                                // rules={[
                                //     { required: true, message: "Please Select Form!" },
                                // ]}
                            >
                                <Select
                                    placeholder="Select Form"
                                    // allowClear
                                    showSearch
                                    onChange={(e) =>
                                        setSelectedIngredientForm(e)
                                    }
                                    filterOption={(inputValue, option) =>
                                        option.children
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase())
                                    }
                                >
                                    <Option value="" disabled hidden>
                                        Select Form
                                    </Option>
                                    {ingredientFormOptions &&
                                        ingredientFormOptions?.length > 0 &&
                                        ingredientFormOptions.map((option) => (
                                            <Option key={option.id}>
                                                {option.name}
                                            </Option>
                                        ))}
                                </Select>
                            </Form.Item>
                            <label className="text-danger">{formErr}</label>
                        </Col>
                        {/* <Col xs={24} md={3} xl={2} xxl={2}>
                            <Form.Item
                                name="quantity"
                                rules={[
                                    // { required: true, message: "Please Insert Quantity!" },
                                    {
                                        pattern: NUMBER_AND_FRACTIONAL_PATTERN,
                                        message:
                                            NUMBER_AND_FRACTIONAL_PATTERN_MESSAGE,
                                    },
                                ]}
                            >
                                <Input
                                    onChange={(e) => {
                                        form.getFieldValue('quantity') !== '' &&
                                        form.getFieldValue('quantity') !== 0 &&
                                        form.getFieldValue('unit') !== ''
                                            ? form.setFieldsValue({
                                                  gram:
                                                      parseFloat(
                                                          form.getFieldValue(
                                                              'gram'
                                                          )
                                                      ) * e.target.value,
                                              })
                                            : form.setFieldsValue({
                                                  gram: 0,
                                                  unit: '',
                                              })
                                    }}
                                    placeholder="Quantity"
                                    className="py-2"
                                />
                            </Form.Item>
                            <label className="text-danger">{quantityErr}</label>
                        </Col> */}
                        {/* <Col xs={24} md={6} xl={4} xxl={4}>
                            <Form.Item
                                name="unit"
                                // rules={[
                                //     { required: true, message: "Please Select Unit!" },
                                // ]}
                            >
                                <Select
                                    placeholder="Select Unit"
                                    // allowClear
                                    showSearch
                                    onChange={() => {
                                        // handleGramValue("unit", e);
                                        // set the default gram value from its selected unit
                                        form.setFieldsValue({
                                            gram:
                                                ingredientUnitOptions?.length >
                                                    0 &&
                                                ingredientUnitOptions.find(
                                                    (record) =>
                                                        record.id ==
                                                        form.getFieldValue(
                                                            'unit'
                                                        )
                                                ).gram *
                                                    (form.getFieldValue(
                                                        'quantity'
                                                    ) || 1),
                                            // console.log(ingredientUnitOptions.find((record)=>record.id==form.getFieldValue('unit')).gram)
                                        })
                                    }}
                                    filterOption={(inputValue, option) =>
                                        option.children
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase())
                                    }
                                >
                                    <Option value="" disabled hidden>
                                        Select Unit
                                    </Option>
                                    {ingredientUnitOptions &&
                                        ingredientUnitOptions?.length > 0 &&
                                        ingredientUnitOptions.map((option) => (
                                            <Option key={option.id}>
                                                {option.name}
                                            </Option>
                                        ))}
                                </Select>
                            </Form.Item>
                            <label className="text-danger">{unitErr}</label>
                        </Col> */}
                        <Col xs={24} md={3} xl={3} xxl={3}>
                            <Input.Group compact className="d-flex">
                                <Form.Item
                                    name="gram"
                                    rules={[
                                        // { required: true, message: "Please Insert Grams!" },
                                        {
                                            // empty is fine while picking other fields; ADD checks it's filled
                                            validator: (_, value) =>
                                                !value || isValidIngredientAmount(value)
                                                    ? Promise.resolve()
                                                    : Promise.reject(new Error(INGREDIENT_AMOUNT_MESSAGE)),
                                        },
                                    ]}
                                >
                                    <Input
                                        placeholder={ingredientMeasurementType}
                                        // typing replaces the "empty" message with the field's own check
                                        onChange={() => setGramErr('')}
                                        className="py-2"
                                        style={{
                                            width: '100%',
                                        }}
                                    />
                                </Form.Item>
                                <Select
                                    suffixIcon={
                                        <CaretDownOutlined
                                            style={{
                                                fontSize: '1rem',
                                                marginTop: '-25px',
                                            }}
                                        />
                                    }
                                    defaultValue="gram"
                                    className="w-100"
                                    onChange={(e) =>
                                        selectedIngredientMeasurementType(e)
                                    }
                                >
                                    <Option value="gram">Gram</Option>
                                    <Option value="ml">ml</Option>
                                </Select>
                            </Input.Group>
                            <label className="text-danger">{gramErr}</label>
                        </Col>
                        <Col xs={24} md={6} xl={3} xxl={3}>
                            {/* <Form.Item
                            name="gram"
                            rules={[
                                { required:true, message: "Please Insert Grams!" },
                            ]}
                        > */}
                            <Button
                                className="bg-primary add-button text-white p-2 b-0 rounded"
                                onClick={() => insertData()}
                                // disabled={
                                //     form.getFieldValue('Ingredients') == undefined ||
                                //     form.getFieldValue('form') == undefined ||
                                //     form.getFieldValue('quantity') == undefined ||
                                //     form.getFieldValue('unit') == undefined ||
                                //     form.getFieldValue('gram') == undefined
                                // }
                            >
                                {/* {console.log(form.getFieldValue('form'))} */}
                                ADD
                            </Button>
                            {/* </Form.Item> */}
                        </Col>
                        <label className="text-danger" id="recipe-ingredients-error">
                            {totalIngredientsErr}
                        </label>

                        {/* ================================== */}
                        {/* Ingredients List (Macros and Micros per serving): */}
                        <Col xs={24} md={24} xl={24} xxl={24}>
                            <label className="form-input-label">
                                Ingredients List (Macros and Micros per serving)
                                :{/* <span className="asterik"> *</span> */}
                            </label>
                            <span className="me-3 float-right">
                                <b>Depriciation (15%)</b>
                                <Switch
                                    checked={depriciation}
                                    disabled={
                                        selectedIngredientsList &&
                                        selectedIngredientsList?.length == 0
                                            ? true
                                            : false
                                    }
                                    onChange={(e) => {
                                        setDepriciation(e)
                                    }}
                                />
                            </span>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={24} xl={14} xxl={14}>
                            <div className="IngredientsList">
                                <HandleIngredientsList />
                            </div>
                        </Col>
                        <Col xs={24} md={24} xl={10} xxl={10}>
                            <div className="MacrosMicrosList">
                                <Collapse
                                    expandIconPosition="end"
                                    //   key={index}
                                    className="mt-1 w-100"
                                >
                                    <Panel
                                        header={
                                            <>
                                                Macros Per Serving
                                                {/* <Popover content="Double click the values to edit manually" style={{width:'10%'}}> */}
                                                <InfoCircleTwoTone className="panelHeaderIcon" />
                                                {/* </Popover> */}
                                            </>
                                        }
                                        key="1"
                                    >
                                        {totalMicros &&
                                            totalMicros?.length > 0 &&
                                            totalMicros.map(
                                                (element, index) =>
                                                    element.type ==
                                                        'Macros' && (
                                                        <Tag key={index}>
                                                            {element.name} :{' '}
                                                            {element?.total?.toFixed(
                                                                2
                                                            ) || 0}{' '}
                                                            {element.unit}
                                                        </Tag>
                                                    )
                                            )}
                                    </Panel>
                                </Collapse>
                                <Collapse
                                    expandIconPosition="end"
                                    //   key={index}
                                    className="mt-1 w-100"
                                >
                                    <Panel
                                        header={
                                            <>
                                                Micros Per Serving
                                                {/* <Popover content="Double click the values to edit manually"> */}
                                                <InfoCircleTwoTone className="panelHeaderIcon" />
                                                {/* </Popover> */}
                                            </>
                                        }
                                        key="1"
                                    >
                                        {totalMicros &&
                                            totalMicros?.length > 0 &&
                                            totalMicros?.map(
                                                (element, index) =>
                                                    // totalMicros.map((element) =>
                                                    element.type ==
                                                        'Micros' && (
                                                        // console.log(element.total)
                                                        <Tag key={index}>
                                                            {element?.name} :{' '}
                                                            {element?.total?.toFixed(
                                                                2
                                                            ) || 0}{' '}
                                                            {element.unit}
                                                        </Tag>
                                                    )
                                            )}
                                    </Panel>
                                </Collapse>
                            </div>
                        </Col>
                        {/* ================================== */}

                        {/* ================================== */}
                        {/* Add Preparation Steps: */}
                        {console.log(
                            'preparation_steps',
                            form.getFieldValue('preparation_steps')
                        )}
                        {console.log('preparationSteps', preparationSteps)}
                        <Col xs={24} md={12} xl={4} xxl={3}>
                            <label className="form-input-label">
                                Add Preparation Steps:
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <label className="text-danger" id="recipe-preparation-steps-error">
                                {preparationStepsErr}
                            </label>
                        </Col>
                        <Form.List
                            name="preparation_steps"
                            initialValue={[{ description: '' }]}
                        >
                            {(fields, { add, remove }) => (
                                <>
                                    <Col
                                        xs={24}
                                        md={24}
                                        lg={24}
                                        xl={20}
                                        xxl={21}
                                    >
                                        <Button
                                            className="bg-primary text-white border-0 text-white rounded"
                                            onClick={() => {
                                                add()
                                            }}
                                        >
                                            Add Step
                                        </Button>{' '}
                                        <br />
                                    </Col>

                                    {fields.map(
                                        (
                                            { key, name, ...restField },
                                            index
                                        ) => (
                                            <Col
                                                xs={24}
                                                md={24}
                                                lg={24}
                                                xl={24}
                                                xxl={24}
                                                key={key}
                                                className="align-self-center align-items-center"
                                            >
                                                <label className="form-input-label mb-1">
                                                    Step {index + 1}:
                                                </label>

                                                <span className="d-flex align-self-center align-items-center">
                                                    <Form.Item
                                                        {...restField}
                                                        name={[
                                                            name,
                                                            'description',
                                                        ]}
                                                        className="w-100"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message:
                                                                    'Please Insert Preparation Steps!',
                                                            },
                                                        ]}
                                                    >
                                                        <Input.TextArea
                                                            placeholder="Description"
                                                            className="preparationStep p-1"
                                                            rows={2}
                                                        />
                                                    </Form.Item>
                                                    {index !== 0 && (
                                                        <Button
                                                            icon={
                                                                <MinusCircleOutlined />
                                                            }
                                                            className="removeIcon rounded"
                                                            onClick={() => {
                                                                remove(name)
                                                            }}
                                                        >
                                                            Remove
                                                        </Button>
                                                    )}
                                                </span>
                                            </Col>
                                        )
                                    )}
                                </>
                            )}
                        </Form.List>
                        {/* ================================== */}

                        <Col xs={24} md={12} xl={12} xxl={12}>
                            <label className="form-input-label">
                                Recipe Description:
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="recipe_description"
                                rules={[
                                    {
                                        required: false,
                                        message:
                                            'Please Insert Recipe Description!',
                                    },
                                ]}
                            >
                                <Input.TextArea
                                    placeholder="Description"
                                    className="p-1"
                                    rows={3}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12} xl={12} xxl={12}>
                            <label className="form-input-label">
                                Recipe Health Benefits:
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="recipe_health_benefits"
                                rules={[
                                    {
                                        required: false,
                                        message:
                                            'Please Insert Recipe Health Benefits!',
                                    },
                                ]}
                            >
                                <Input.TextArea
                                    placeholder="Health Benefits"
                                    className="p-1"
                                    rows={3}
                                />
                            </Form.Item>
                        </Col>
                        {/* <Col xs={24} md={12} xl={8} xxl={8}>
                            <label className="form-input-label">
                                Recipe Image:
                            </label>
                            <Form.Item
                                name="image"
                                rules={[
                                    {
                                        required: false,
                                        message: "Please Select Image!",
                                    },
                                ]}
                            >
                                <Input type="file"
                                    suffix={priviewImg ? <CloseOutlined
                                        onClick={() => { form.setFieldValue('image', ''); setPriviewImg(''); setfile('') }} /> : <></>}
                                    onChange={(e) => imagePreview(e)} className="mt-2 p-1" />
                                {file && (
                                    <img src={priviewImg || ''} className="mt-2 text-center" alt="360" width={200} />
                                )}
                            </Form.Item>
                        </Col> */}
                        {/* <Col xs={24} md={12} xl={3} xxl={3} className='mt-5'>
                        <span className="d-flex justify-content-center">
                            <label className="form-input-label">
                                Verified?:
<span className="asterik"> *</span> 
                            </label>
                            <Form.Item
                                // label="Verified?"
                                name="verified"
                            // rules={[
                            //     { required:true, message: "Please Insert Recipe Health Benefits!" },
                            // ]}
                            >
                                <Checkbox className="ps-2 ms-2 p-1" />
                            </Form.Item>
                        </span>
                    </Col>
 */}
                        {/* <Col xs={24} md={12} xl={11} xxl={3} className='mt-5'>
                        <label className="form-input-label">
                            Last Updated By: NA
                            <span className="asterik"> *</span>
                        </label>
                    </Col>
                    <Col xs={24} md={12} xl={11} xxl={3} className='mt-5'>
                        <label className="form-input-label">
                            Last Verified By: NA
                            <span className="asterik"> *</span>
                        </label>
                    </Col> */}
                        {/* <Col xs={24} md={12} xl={11} xxl={6} className='mt-4'>
                        <label className="form-input-label">
                            How do you want to save the recipe?
                            <span className="asterik"> *</span>
                        </label>
                        <Form.Item
                            // label="Verified?"
                            name="verfied"
                            rules={[
                                { required:true, message: "Please Insert Recipe Health Benefits!" },
                            ]}
                        >
                            <Radio.Group className="radio_btn_list mt-2">
                                <Radio value="Save locally"> Save locally</Radio>
                                <Radio value="Create new recipe in sdatabase">Create new recipe in database</Radio>
                            </Radio.Group>                        </Form.Item>
                    </Col> */}
                        <Col span={24} className="text-center mb-2">
                            <Button
                                htmlType="submit"
                                loading={saving}
                                className="submit-button b-0 rounded"
                            >
                                {id ? 'UPDATE' : 'SAVE'}
                            </Button>
                            <Button
                                onClick={() => resetData()}
                                className="reset-button ms-4 b-0 rounded"
                            >
                                RESET
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Spin>
        </div>
    )
}
